const chart1 = 'radar';
const chart2 = chart1;
const stacked = true;
//(nenhum texto deve aceitar html, apenas texto simples)
/* ===== API publica ===== */
/**
 * Configuração de exemplo para gráfico completo com séries, tooltip e drilldown.
 * @public
 */
export default {
  element: 'chart',
  parent: 'main',
  // type: 'spline',// [line/spline/area/sparea/bar/column/pie/bubble]    obrigatório 
  plotOptions: {
    pie: {
      // explode: 'bigger',
      labelMode: 'value', //[value/percentage/both] opcional padrão value
      radius: {
        inner: 60, //padrão: 0
        outer: 100, //padrão: 100 
      },
      caption: { show: true, offset: 'center', color: '#cdd1d5' }
    },
    bubble: {
      opacity: .75
    },
    radar: {
      filled: false, //true/false opcional padrão false
      type:'spider'
    },
    tooltip: {
      enabled: true, //opcional. padrão: true
      background: 'black',//opcional sem padrão, se não houver nada aqui, será controlado pelo css (charts.scss)
      border: 'solid white 1px',//opcional sem padrão, se não houver nada aqui, será controlado pelo css (charts.scss)
      colorText: 'black',//opcional sem padrão, se não houver nada aqui, será controlado pelo css (charts.scss)
      title: 'Temperatura',//opcional. Padrão '{name}';
      formatted: '{value}°',
      text: 'Temperatura de {series.name} em {name}: {formatted}'//opcional. Padrão '{value}' (Quando em stacked: true o padrão deve ser {series.name}: {formatted} para cada valor e no final Total:{formatted})
    }
  },
  stacked: {
    enabled: stacked,
    mode: 'net',
    gap: 5,
    fixed: 1,
    format: '{value}°'
  },
  // theme: 'dark',//opcional com padrão dark
  title: 'Monthly Average Temperature',//opcional sem padrão 
  subtitle: 'Source: Wikipedia.com',//opcional sem padrão
  legend: 'bottom', // [top/bottom/left/right/top-left/top-right/bottom-left/bottom-right/false] opcional com padrão bottom
  xAxis: {//obrigatório
    title: 'Months',//opcional sem padrão
    labels: {//No caso do gráfico ser do tipo bar
      format: '{value}'//opcional com padrão '{value}'
    },
    grid: true //opcional padrão false (cria linhas verticais)
  },
  yAxis: {//obrigatório
    title: 'Temperature',//opcional sem padrão
    labels: {//Com exceção do tipo bar
      // format: '{value}°'//opcional com padrão '{value}'
    },
    // grid: true //opcional padrão true (cria linhas horizontais)
  },
  series: [
    { //pelo menos um registro é obrigatório
      name: 'Sapporo',//obrigatório
      // type: chart1,
      options: { //opcional
        // percentage: false, //[true/false] opcional. Padrão false. converte os valores em portentagem
        // percentage: false, //[true/false] opcional. Padrão false. converte os valores em portentagem
        // stacked: false, // [true/false] opcional. padrão true para area e sparea, false para column e bar. idiferente para line, spline e pie
        dataLabels: {
          //   enabled: true, //[true/false] opcional. Padrão true
          //   position: 'top', //[top/bottom/left/right/inside/outside]opcional. padrão top para line, spline, area, sparea, column. padrão right para bar, outside para pie, inside para bubble
          //   offset: 10, // ocional. padrão 6px, distância ajustável entre o texto e o gráfico
          //   condition: 'all', //[all/bigger/smaller/[especifica]] No caso da específica pode ser algo como >40, <=0, between 10..30, 10..30, [10..30] (esses 3 são iguais) (10..30) exclui as bordas [10, 30] funciona como in. Opcional. Padrão all   
          format: '{value}°' //opcional. Padrão '{value}'
        },
        // marker: {
        //   enabled: true, //[true/false] opcional.
        //   // symbol: '/image/moon.png',//opcional, se não houver nada aqui, pegará o símbolo referente à série. O símbolo também poderá vir de um arquivo interno como é o exemplo aqui
        //   symbol: 'triangle',//opcional, se não houver nada aqui, pegará o símbolo referente à série. O símbolo também poderá vir de um arquivo interno como é o exemplo aqui
        //   condition: 'all', //[all/bigger/smaller/[especifica]] No caso da específica pode ser algo como >40 ou <0. Opcional. Padrão all        
        //   align: 'top',
        //   offset: 10
        // },
        // color: 'cyan', //opcional se não tiver cor, vai pegar a cor em color options ou no css
        // colorBase: true, //opcional, padrão true. Em true todos os dados da série possuem a mesma cor. Em false, cada dado terá uma cor diferente (cores diferentes válidas apenas para column, bar e pie)
      },
      data: [
        { name: 'Jan', /*obrigatório*/ value: -2.9, /*obrigatório color: 'blue',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'sapporo_jan' /* Gerado automaticamente */ },
        { name: 'Fev', /*obrigatório*/ value: -3.6, /*obrigatório color: 'green',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'sapporo_fev' /* Gerado automaticamente */ },
        { name: 'Mar', /*obrigatório*/ value: -0.6, /*obrigatório color: 'yellow',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'sapporo_mar' /* Gerado automaticamente */ },
        { name: 'Abr', /*obrigatório*/ value: 4.8, /*obrigatório color: 'red',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'sapporo_abr' /* Gerado automaticamente */ },
        { name: 'Mai', /*obrigatório*/ value: 10.2, /*obrigatório color: 'cyan',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'sapporo_mai' /* Gerado automaticamente */ },
        { name: 'Jun', /*obrigatório*/ value: 14.5, /*obrigatório color: 'purple',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'sapporo_jun' /* Gerado automaticamente */ },
        { name: 'Jul', /*obrigatório*/ value: 17.6, /*obrigatório color: 'white',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'sapporo_jul' /* Gerado automaticamente */ },
        { name: 'Ago', /*obrigatório*/ value: 16.5, /*obrigatório color: 'pink',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'sapporo_ago' /* Gerado automaticamente */ },
        { name: 'Set', /*obrigatório*/ value: 12.0, /*obrigatório color: 'yellowgreen',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'sapporo_set' /* Gerado automaticamente */ },
        { name: 'Out', /*obrigatório*/ value: 6.5, /*obrigatório color: 'brown',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'sapporo_out' /* Gerado automaticamente */ },
        { name: 'Nov', /*obrigatório*/ value: 2.0, /*obrigatório color: 'orange',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'sapporo_nov' /* Gerado automaticamente */ },
        { name: 'Dez', /*obrigatório*/ value: -0.9, /*obrigatório color: 'darkblue',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'sapporo_dez' /* Gerado automaticamente */ },
      ],//obrigatório
    },
    { //pelo menos um registro é obrigatório
      name: 'Tokyo',//obrigatório
      // type: chart2, //opcional. Se não existir segue o type padrão, no caso aqui, line
      options: { //opcional
        percentage: false, //[true/false] opcional. Padrão false. converte os valores em portentagem
        stacked: false, // [true/false] opcional. padrão true para area e sparea, false para column e bar. idiferente para line, spline e pie
        dataLabels: {
          // enabled: true, //[true/false] opcional. Padrão true
          // position: 'bottom', //[top/bottom/left/right/inside/outside]opcional. padrão top para line, spline, area, sparea, column. padrão right para bar, outside para pie, inside para bubble
          // offset: 10, // ocional. padrão 6px, distância ajustável entre o texto e o gráfico
          // condition: '>30', //[all/bigger/smaller/[especifica]] No caso da específica pode ser algo como >40, <=0, between 10..30, 10..30, [10..30] (esses 3 são iguais) (10..30) exclui as bordas [10, 30] funciona como in. Opcional. Padrão all        
          format: '{value}°', //opcional. Padrão '{value}'
          fixed: 1 //opcional. Padrão 1
        },
        // marker: {
        //   enabled: true, //[true/false] opcional.
        //   // symbol: '/image/sun.png',//opcional, se não houver nada aqui, pegará o símbolo referente à série. O símbolo também poderá vir de um arquivo interno como é o exemplo aqui
        //   symbol: 'diamond',//opcional, se não houver nada aqui, pegará o símbolo referente à série. O símbolo também poderá vir de um arquivo interno como é o exemplo aqui
        //   condition: '>30', //[all/bigger/smaller/[especifica]] No caso da específica pode ser algo como >40, <=0, between 10..30, 10..30, [10..30] (esses 3 são iguais) (10..30) exclui as bordas [10, 30] funciona como in. Opcional. Padrão all   
        // },
        color: '#FF6000', //opcional se não tiver cor, vai pegar a cor em color options ou no css
        // colorBase: true, //opcional, padrão true. Em true todos os dados da série possuem a mesma cor. Em false, cada dado terá uma cor diferente (cores diferentes válidas apenas para column, bar e pie)
      },
      data: [
        { name: 'Jan', /*obrigatório*/ value: 16.0, /*obrigatório color: 'blue',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'tokyo_jan' /* Gerado automaticamente */ },
        { name: 'Fev', /*obrigatório*/ value: 18.2, /*obrigatório color: 'green',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'tokyo_fev' /* Gerado automaticamente */ },
        { name: 'Mar', /*obrigatório*/ value: 23.1, /*obrigatório color: 'yellow',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'tokyo_mar' /* Gerado automaticamente */ },
        { name: 'Abr', /*obrigatório*/ value: 27.9, /*obrigatório color: 'red',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'tokyo_abr' /* Gerado automaticamente */ },
        { name: 'Mai', /*obrigatório*/ value: 32.2, /*obrigatório color: 'cyan',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'tokyo_mai' /* Gerado automaticamente */ },
        { name: 'Jun', /*obrigatório*/ value: 36.4, /*obrigatório color: 'purple',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'tokyo_jun' /* Gerado automaticamente */ },
        { name: 'Jul', /*obrigatório*/ value: 39.8, /*obrigatório color: 'white',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'tokyo_jul' /* Gerado automaticamente */ },
        { name: 'Ago', /*obrigatório*/ value: 38.4, /*obrigatório color: 'pink',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'tokyo_ago' /* Gerado automaticamente */ },
        { name: 'Set', /*obrigatório*/ value: 29.2, /*obrigatório color: 'yellowgreen',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'tokyo_set' /* Gerado automaticamente */ },
        { name: 'Out', /*obrigatório*/ value: 22.0, /*obrigatório color: 'brown',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'tokyo_out' /* Gerado automaticamente */ },
        { name: 'Nov', /*obrigatório*/ value: 17.8, /*obrigatório color: 'orange',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'tokyo_nov' /* Gerado automaticamente */ },
        { name: 'Dez', /*obrigatório*/ value: 16.2, /*obrigatório color: 'darkblue',/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ id: 'tokyo_dez' /* Gerado automaticamente */ },
      ],//obrigatório
    },
  ],
  drilldown: {//opcional, mas se existir, os dados das séries viram links para a nova série, linkando pelos ids
    breadcrumbs: 'right', //[left/right] opcional, padrão right (define se os breadcrumbs ficarão do lado esquerdo ou direto da tela)
    series: [
      { //pelo menos um registro é obrigatório
        name: 'tokyo_jan',//obrigatório
        //color aui não existe, segue a cor do dado pai
        data: [
          { name: '03', /*obrigatório*/ value: 16.0, /*obrigatório*/ color: 'blue'/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ },
          { name: '07', /*obrigatório*/ value: 18.2, /*obrigatório*/ color: 'green'/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ },
          { name: '09', /*obrigatório*/ value: 17.1, /*obrigatório*/ color: 'yellow'/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ },
          { name: '12', /*obrigatório*/ value: 14.9, /*obrigatório*/ color: 'red'/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ },
          { name: '17', /*obrigatório*/ value: 15.2, /*obrigatório*/ color: 'cyan'/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ },
          { name: '22', /*obrigatório*/ value: 16.4, /*obrigatório*/ color: 'purple'/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ },
          { name: '26', /*obrigatório*/ value: 15.8, /*obrigatório*/ color: 'white'/* opcional se não tiver cor, vai pegar a cor em color options ou no css */ },
          //...continua
        ],
      },
    ],
  },

}
